import type { PropsWithChildren } from 'react';

export const ScrollableTable = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <div className="relative rounded-2xl border border-secondary-200 bg-white shadow-xs after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-10 after:rounded-r-2xl after:bg-gradient-to-l after:from-white after:to-transparent md:after:hidden">
      <div className="overflow-x-auto rounded-2xl">{children}</div>
    </div>
  );
};
